import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "./ShopInfoMain/style/eyes.css";
import productData from "../../json/product.json";
import { FaTruck } from "react-icons/fa";
import { GiThermometerScale } from "react-icons/gi";
import { SlCalender } from "react-icons/sl";
import { Tooltip } from "react-tooltip";
import { IoColorWandOutline } from "react-icons/io5";
import { FaTags } from "react-icons/fa";
import { GiAbbotMeeple } from "react-icons/gi";
import { Accordion, AccordionSummary, AccordionDetails, Rating } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Eyes({ itemId }) {

  const [leftImages, setLeftImages] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const productId = itemId;
  const data = productData?.newPrd?.filter((x) => x.id === productId);

  const handleCarouselChange = (index) => {
    setLeftImages(data.slice(index, index + 4));
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div
      className="flex justify-center"
      style={{ margin: "10px 10px 0px 0px" }}
    >
      <div className="eyes-shop1" style={{ direction: "row" }}>
        <div className="eyes-image-info">
          <div className="eyes-shopslider-container">
              <Carousel
                className="eyes-shopslider"
                onChange={handleCarouselChange}
                showArrows={true}
                preventMovementUntilSwipeScrollTolerance={50}
              >
                {data &&
                  data?.map(
                    (x, index) =>
                      x?.prdDetalis &&
                      JSON.parse(x?.prdDetalis).map((image, i) => (
                        <img
                          key={`${index}-${i}`}
                          src={image?.url}
                          alt={x?.title}
                          style={{ width: "100%", height: "100%" }}
                        />
                      ))
                  )}
              </Carousel>
            <div className="left-images">
              {leftImages.map((image, index) => (
                <img
                  key={index}
                  src={image.url}
                  alt={image.title}
                  style={{ width: "100%", height: "100%" }}
                />
              ))}
            </div>
          </div>
          <div className="eyes-infomain">
            <div className="eyes-shopaccoding">
              {data &&
                data?.map((x, i) => (
                  <div key={i}>
                    <div>
                      <p className="mb-2 mt-2 text-slate-500 text-3xl font-medium">
                        {x.prdname}
                      </p>
                      <p className="my-5 tracking-wider text-gray-600 ">
                        {x.decs}
                      </p>
                      <p className="mb-3 tracking-wider text-gray-800">
                        <span className="my-2 font-semibold">
                          Price : Price on Request
                        </span>
                        <p className="text-sm tracking-wider ">
                          *The price of this item will vary based on grammage
                          and the gold rate on that particular day call us{" "}
                        </p>
                        <a href="tel:+918511183836" className="underline">
                          +1-847-555-5555
                        </a>
                      </p>
                    </div>
                    <div className="flex mb-3 justify-center align-center rating ">
                      <div>
                        {x.rating ? (
                          <span>
                            <Rating
                              name="read-only"
                              value={x.rating}
                              size="small"
                              className="mt-1"
                            />
                          </span>
                        ) : (
                          <span></span>
                        )}
                      </div>
                      <p className="ms-2 text-md text-slate-500">reviews</p>
                    </div>
                  </div>
                ))}
              <div className="my-5 eyes-dec">
                <p className="flex mr-2 eyes-dec1">
                  <span className="text-lg">
                    <FaTruck />
                  </span>
                  <span className="uppercase text-xs font-medium ms-2 tracking-wider">
                    {" "}
                    DELIVERY & RETURN
                  </span>
                </p>
                <p className="flex mr-2 my-3 eyes-dec1">
                  <span className="text-lg">
                    <GiThermometerScale />
                  </span>
                  <span className="uppercase text-xs font-medium ms-2 tracking-wider">
                    {" "}
                    size
                  </span>
                </p>
                <p className="flex mr-2 eyes-dec1">
                  <span className="text-lg">
                    <SlCalender />
                  </span>
                  <span className="uppercase text-xs font-medium ms-2 tracking-wider">
                    {" "}
                    ESTIMATED DELIVERY : 1week
                  </span>
                </p>
              </div>
              <div>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                  sx={{ boxShadow: "none" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className="text-black tracking-wider text-lg"
                  >
                    Description
                  </AccordionSummary>
                  <AccordionDetails>
                    {data?.map((x, i) => (
                      <p key={i}>{x?.desc}</p>
                    ))}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                  sx={{ boxShadow: "none" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                    className="text-black tracking-wider text-lg"
                  >
                    Additional Information
                  </AccordionSummary>
                  <AccordionDetails>
                    {data?.map((x, i) => (
                      <div key={i}>
                        <table>
                          <tbody>
                            <tr>
                              <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                                Weight
                              </th>
                              <td className="text-gray-500 ms-5">1 kg</td>
                            </tr>
                            <tr className="py-5">
                              <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                                Dimensions
                              </th>
                              <td className="text-gray-500">10 × 11 × 22 cm</td>
                            </tr>
                            <tr>
                              <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                                Color
                              </th>
                              <td>
                                {x.jwelleryColour} (Colour was customization)
                              </td>
                            </tr>
                            <tr className="my-2">
                              <th className="text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2">
                                Sizes
                              </th>
                              <td>10K, 18K, 22K, 24K</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                  sx={{ boxShadow: "none" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                    className="text-black tracking-wider text-lg"
                  >
                    Review
                  </AccordionSummary>
                  <AccordionDetails>
                    {data?.map((x, i) => (
                      <div key={i}>
                        <div className="text-center text-lg text-gray-600">
                          5 reviews for {x?.prdname}
                        </div>
                        <div className="rating-box-main1">
                          <div className="ratingbox-1-1 bg-gray-100 py-2">
                            <div className="text-5xl font-semibold  ">5.0</div>
                            <div>
                              {x.rating ? (
                                <span>
                                  <Rating
                                    name="read-only"
                                    value={x.rating}
                                    size="small"
                                    className="mt-1"
                                  />
                                </span>
                              ) : (
                                <span></span>
                              )}
                            </div>
                            <div className="text-gray-600">
                              Based on 5 reviews
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                  sx={{ boxShadow: "none" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                    className="text-black tracking-wider text-lg"
                  >
                    Information
                  </AccordionSummary>
                  <AccordionDetails>
                    {data?.map((x, i) => (
                      <div key={i}>
                        <div>
                          <p className="my-3 flex">
                            <Tooltip id="my-tooltip" />
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content="TAGS"
                              className="uppercase text-xl font-semibold tracking-wide ms-2 text-gray-600 "
                            >
                              <FaTags />
                            </a>
                            <span className="text-black text-sm tracking-wider font-semibold">
                              : Bestseller, Trend
                            </span>
                          </p>
                          <p className="my-3 flex">
                            <Tooltip id="my-tooltip" />
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content="Jwellery Material"
                              className="uppercase text-xl font-semibold tracking-wide ms-2 text-gray-600 "
                            >
                              <GiAbbotMeeple />
                            </a>
                            <span className="text-black text-sm tracking-wider font-semibold">
                              : {x.jwelleryMaterial}
                            </span>
                          </p>
                          <p className="my-3 flex">
                            <Tooltip id="my-tooltip" />
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content="Jwellery Color"
                              className="uppercase text-xl font-semibold tracking-wide ms-2 text-gray-600 "
                            >
                              <IoColorWandOutline />
                            </a>
                            <span className="text-black text-sm tracking-wider font-semibold">
                              : {x.jwelleryColour}
                            </span>
                          </p>
                        </div>
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                  sx={{ boxShadow: "none" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5bh-content"
                    id="panel5bh-header"
                    className="text-black tracking-wider text-lg"
                  >
                    Q & A
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="flex mt-5">
                      <p className="border w-10/12 flex">
                        <input type="text" placeholder="Search Answers" />
                      </p>
                      <span className="rounded-none ms-4 px-10 bg-black text-white">
                        Ask a question
                      </span>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Eyes;
